import styled from "styled-components";

export const ReportsWrapper = styled.div`
     width: calc(100% - 1.5rem);
padding: 16px;
`;

export const Divider = styled.div`
  border: 1px solid #e5e7eb;  
  margin: 10px 0;
`;
